import { Box } from '@mui/material';
import React from 'react';
import CardProps from '../../@types/Card.type';
import './Card.scss';

// Printer, packet and FlightData components will be passed as children prop to this Card Component
const Card: React.FC<CardProps> = ({ title, stepNumber, children }) => {
  return (
    <Box p={3} width="100%" className="card">
      <h3 className=".auro_heading--400">
        {stepNumber}. {title}
      </h3>
      {children}
    </Box>
  );
};

export default Card;
